/** @format */

import React, { useState } from 'react'
import { _$, Card, Tabs, Tab } from '@king-design/react'
import styled from 'styled-components'
import CustomPageContainer from 'src/components/CustomPageContainer'
import { useLocation, useHistory } from 'react-router'
import HeaderFilter from '../../components/HeaderFilter'
import { initSearch } from '../../components/constant'
import { ServiceOverviewSearchProps } from '../../components/typescript'
import Overview from '../container/Overview'
import ChartRow from '../container/ChartRow'
import SessionContainer from '../../SessionAnalysis/container'
import TraceContainer from '../../TraceAnalysis/container'
import useNavRegion from 'src/hooks/useNavRegion'
import { replaceSearchParams } from 'src/utils'
function useQuery() {
  return new URLSearchParams(useLocation().search)
}

type TabType = 'overview' | 'session' | 'trace'
// 嵌入页面隐藏面包屑
const IS_TOP_WINDOW: boolean = window.self === window.top

const ServiceOverview: React.FC<{ className?: string }> = ({ className }) => {
  const history = useHistory()
  const query = useQuery()
  const location = useLocation()
  const serviceName = query.get('serviceName')
  const quickKey = query.get('quickKey')
  const startTime = query.get('startTime')
  const endTime = query.get('endTime')
  const query_tab = query.get('tab') || 'overview'
  const [filterSearch, setFilterSearch] = useState<ServiceOverviewSearchProps>(() => {
    const init = initSearch(quickKey)
    if (startTime && endTime) {
      init.time = [parseFloat(startTime), parseFloat(endTime)]
    }
    return init
  })
  // 控制台region
  const region = useNavRegion()

  // 服务Tab
  const [tab, setTab] = useState<TabType>(query_tab as TabType)
  return (
    <div className={className}>
      <CustomPageContainer
        showBack
        onBack={() => {
          history.push('/monitor/aiobservability/serviceoverview')
        }}
        title={serviceName}
        showHeader={IS_TOP_WINDOW}
      >
        <Card type="none" className="service-detail-card">
          <HeaderFilter quickKey={quickKey} value={filterSearch} onChange={setFilterSearch} />
          <Tabs
            className="service-detail-tabs"
            value={tab}
            onChangeValue={v => {
              setTab(v as TabType)
              replaceSearchParams(history, location, {
                tab: v
              })
            }}
          >
            <Tab value="overview">{_$('运行时总览')}</Tab>
            <Tab value="session">{_$('会话分析')}</Tab>
            <Tab value="trace">{_$('Trace分析')}</Tab>
          </Tabs>
          {tab === 'overview' ? (
            <>
              <Overview
                serviceName={serviceName}
                startTime={filterSearch.time[0]}
                endTime={filterSearch.time[1]}
                region={region}
              />
              <ChartRow
                serviceName={serviceName}
                startTime={filterSearch.time[0]}
                endTime={filterSearch.time[1]}
                aggregate={filterSearch.aggregateType}
                region={region}
              />
            </>
          ) : null}
          {tab === 'session' ? (
            <SessionContainer
              headerSearch={filterSearch}
              serviceName={serviceName}
              region={region}
            />
          ) : null}
          {tab === 'trace' ? (
            <TraceContainer headerSearch={filterSearch} serviceName={serviceName} region={region} />
          ) : null}
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(ServiceOverview)`
  .service-detail-tabs {
    margin: 16px 0;
  }
`
